// Base styles
import * as checkboxStatic from "assets/components-static-styles/components/form/checkbox";
import borders from "assets/theme/base/borders";
import { hmoAwareColors as colors } from "assets/theme/getHmoAwareColors";

// Helper functions
import { merge } from "lodash";
import linearGradient from "assets/theme/functions/linearGradient";

const { borderWidth, borderColor } = borders;
const { transparent, primary } = colors;

// types
type Types = any;

const themeStyles = {
  styleOverrides: {
    root: {
      "& .MuiSvgIcon-root": {
        color: transparent.main,
        border: `${borderWidth[1]} solid ${primary.main}`,
      },

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-focusVisible": {
        border: `${borderWidth[2]} solid ${primary.main} !important`,
      },
    },

    colorPrimary: {
      color: primary.main,

      "&.Mui-checked": {
        color: primary.main,

        "& .MuiSvgIcon-root": {
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), ${linearGradient(
            primary.main,
            primary.main
          )}`,
          borderColor: primary.main,
        },
      },
    },

    colorSecondary: {
      color: primary.main,

      "& .MuiSvgIcon-root": {
        color: primary.main,
        "&.Mui-checked": {
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), ${linearGradient(
            primary.main,
            primary.main
          )}`,
          borderColor: primary.main,
        },
      },
    },
  },
};
const checkbox: Types = merge(themeStyles, checkboxStatic.default);

export default checkbox;
